export enum InlineCommentMode {
	EDIT = 'edit',
	VIEW = 'view',
	LIVE = 'live',
}
